import { Component, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { MatPaginator, MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import { ActivatedRoute } from "@angular/router";
import { CommonModule } from "@angular/common";
import { TechnicalLetterService } from "../../services/technical-letters/technical-letter.service";
import { LetterEquipmentDoc } from "../../interfaces/technical-letters/letter-equipment-doc.models";
import { CalAngularService } from "@cvx/cal-angular";

@Component({
    selector: "app-letter-equipment-doc",
    imports: [
        CommonModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule
    ],
    templateUrl: "./letter-equipment-doc.component.html"
})
export class LetterEquipmentDocComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = ["when", "by", "document"];
  dataSource = new MatTableDataSource<LetterEquipmentDoc>([]);
  loading = false;
  error: string | null = null;
  letterEquipmentId: number;
  selectedFile: File | null = null;

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(private route: ActivatedRoute,
    private technicalLetterService: TechnicalLetterService,
    private authService: CalAngularService
  ) { }

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get("id");
    if (id) {
      this.letterEquipmentId = Number(id);
      this.loadLetterEquipmentDocs();
    } else {
      this.error = "No letter equipment ID provided.";
    }
  }

  loadLetterEquipmentDocs(): void {
    this.loading = true;
    this.error = null;
    this.technicalLetterService.getLetterEquipmentDoc(this.letterEquipmentId).subscribe({
      next: (data: LetterEquipmentDoc[]) => {
        this.dataSource.data = data;
        this.loading = false;
      },
      error: (err) => {
        console.error("Error loading letter equipment documents:", err);
        this.loading = false;
      }
    });
  }

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.selectedFile = file;
    }
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  uploadFile() {
    const fileInput = document.getElementById("fileUpload") as HTMLInputElement;
    const file = fileInput.files?.[0];
    if (!file) {
      console.error("No file selected");
      return;
    }

    this.technicalLetterService.UploadFileOnSharepoint(file)
      .subscribe({
        next: (response) => {
          response.url;
          this.addLetterEquipmentDoc(response.url);
        },
        error: (err) => {
          console.error("Error uploading file:", err);
        }
      });
  }

  addLetterEquipmentDoc(documentUrl: string): void {
    let userInfo = this.authService.getAccount();
    if (!this.selectedFile) {
      console.error("No file selected for upload");
      return;
    }

    const letterEquipmentDoc: LetterEquipmentDoc = {
      id: 0,
      letterEquipmentId: this.letterEquipmentId,
      documentUrl: documentUrl,
      rowCreatedBy: userInfo.username,
      rowCreatedDate: new Date().toISOString(),
      rowUpdatedBy: userInfo.username,
      rowUpdatedDate: new Date().toISOString(),
      documentName: this.selectedFile.name
    };

    this.technicalLetterService.addLetterEquipmentDoc(letterEquipmentDoc)
      .subscribe({
        next: () => {
          this.loadLetterEquipmentDocs();
        },
        error: (err) => {
          console.error("Error adding document:", err);
        }
      });
  }
}